import React, { Component } from 'react';
import { pick } from 'ramda';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import GuestLayout from './GuestLayout';
import UserLayout from './UserLayout';

@withRouter
@connect(pick(['token', 'app']))
export default class SecureLayout extends Component {

    componentDidMount() {
        const token = window.location.href.split('?').pop()
        const verify_email = window.location.href.split('?').shift().split('/').pop() 
        if(verify_email === 'verify-email') {
            window.location.replace('/email_verification')
            localStorage.setItem('email_verification', token)
        }
    }

    render() {
        if (!this.props.app) {
            return null;
        }
        
        return this.props.token ? (
            <UserLayout {...this.props} />
        ) : (
            <GuestLayout {...this.props} />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/layout/SecureLayout.js